import { useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { useQuery } from "@tanstack/react-query";
import {
  Flex,
  Table,
  Button,
  TableRow,
  NoResults,
  TableBody,
  TableCell,
  TableHead,
  PageWrapper,
  PanelSlider,
  StretchPanel,
  TableHeadCell,
} from "@ubisend/pulse-components";

import { UserDetails } from "./index";

dayjs.extend(relativeTime);

const Report = ({ match: { params } }) => {
  const [showUsers, setShowUsers] = useState(false);

  const { data, isLoading } = useQuery({ queryKey: [`reports/${params.id}`] });

  return (
    <PageWrapper header={"Reporting"}>
      <StretchPanel>
        <Table loading={isLoading} loadingColumns={6}>
          {!isLoading && data && (
            <>
              {!data.clients.length === 0 && <NoResults />}
              {data.clients.length > 0 && (
                <TableHead>
                  <TableRow>
                    <TableHeadCell>Client Name</TableHeadCell>
                    <TableHeadCell>Client Email</TableHeadCell>
                    <TableHeadCell
                      row={{ label: "Number of users", sort: "users_total" }}
                    />
                    <TableHeadCell>Country</TableHeadCell>
                    <TableHeadCell>Created At</TableHeadCell>
                    <TableHeadCell>Actions</TableHeadCell>
                  </TableRow>
                </TableHead>
              )}
              <TableBody>
                {data.clients.map(
                  ({ country, email, name, users, created_at }, key) => (
                    <TableRow key={key}>
                      <TableCell>{name}</TableCell>
                      <TableCell>{email}</TableCell>
                      <TableCell>{users.length}</TableCell>
                      <TableCell>{country || "N/A"}</TableCell>
                      <TableCell>{`${dayjs(created_at)}`}</TableCell>
                      <TableCell>
                        <Flex>
                          <Button
                            disabled={users.length === 0}
                            icon="eye"
                            onClick={() => setShowUsers(users)}
                            variant="secondary"
                          >
                            Users
                          </Button>
                        </Flex>
                      </TableCell>
                    </TableRow>
                  ),
                )}
              </TableBody>
            </>
          )}
        </Table>
      </StretchPanel>
      {showUsers && (
        <PanelSlider header="View users" handleHide={() => setShowUsers(false)}>
          <UserDetails users={showUsers} />
        </PanelSlider>
      )}
    </PageWrapper>
  );
};

export default Report;
